const tabEquip = {
  equip: 'EQUIPMENT',
  service: 'SERVICES',
  action: 'ACTIONS',
  attachFiles: 'ATTACHMENT FILES',
  maintenance: 'MAINTENANCE',
  equipFinance: 'FINANCIAL',
};

export default tabEquip;
